import { render, staticRenderFns } from "./matterClass.vue?vue&type=template&id=65cdc29c&"
import script from "./matterClass.vue?vue&type=script&lang=js&"
export * from "./matterClass.vue?vue&type=script&lang=js&"
import style0 from "./matterClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports